import { useCallback } from 'react';

import { useFbPixelByProduct } from '../../facebookPixel';
import { Params as FbPixelParams } from '../../facebookPixel/types';
import { useBrazeByProduct } from '../../braze';
import { Params as BrazeParams } from '../../braze/logBrazeEvent';

interface Params {
  fbPixel: FbPixelParams;
  braze: BrazeParams;
}

const useLogByProduct = ({ fbPixel, braze }: Params) => {
  const { fbPixelClickReservation } = useFbPixelByProduct(fbPixel);
  const { brazeClickReservation, brazeAddWishlist } = useBrazeByProduct(braze);
  const logClickReservation = useCallback(() => {
    brazeClickReservation();
    fbPixelClickReservation();
  }, [brazeClickReservation, fbPixelClickReservation]);
  const logAddWishlist = useCallback(brazeAddWishlist, [brazeAddWishlist]);

  return { logClickReservation, logAddWishlist };
};

export default useLogByProduct;
